enum EPlatformNames {
  all= 'all',
  github = 'github',
  trello = 'trello',
  gitlab = 'gitlab',
  jira = 'jira',
  notion = 'notion',
  shopify = 'shopify',
  chatgpt = 'chatgpt',
  claude = 'claude'
}

export default EPlatformNames;
